import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Skeleton, SkeletonText, Separator } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"



import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"

import _ from "lodash"
import { useStore } from "contexts/store";
const BottomSheet = ({ open, onOpenChange, title, children, bodyPaddingX = 4, bodyPaddingBottom = 4 }) => {


    return (
        <div>
            <Drawer.Root open={open} onOpenChange={(e) => onOpenChange(e.open)} placement="bottom" closeOnEscape={false} closeOnInteractOutside={false} unmountOnExit={true} >
                <Drawer.Backdrop />
                <Drawer.Positioner >
                    <Drawer.Content>
                        <Container maxW={"md"} maxHeight={"100vh"} overflow={"scroll"} style={{ padding: 0 }}>
                            <Drawer.Header>
                                <div style={{ display: "flex", gap: 4 }}>
                                    <div style={{ flexGrow: 1, flexShrink: 1, justifyContent: "center" }}>
                                        <Drawer.Title>{title}</Drawer.Title>
                                    </div>
                                    <div>
                                        <Drawer.CloseTrigger asChild>
                                            <CloseButton size="lg" />
                                        </Drawer.CloseTrigger>
                                    </div>

                                </div>


                            </Drawer.Header>
                            <Drawer.Body px={bodyPaddingX} pb={bodyPaddingBottom}>

                                <Container maxW={"md"} px="0">
                                    {children}
                                </Container>

                            </Drawer.Body>

                            <Drawer.CloseTrigger />

                        </Container>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Drawer.Root>


        </div>
    )
}

export default memo(BottomSheet)